import { html } from 'lit';
import type { TemplateResult } from 'lit';

/**
 * Launcher glyphs for the three apps, mirroring the product icons on www.pinakes.be
 * (Font Awesome 4.7: 'search' = Pinakes Consult/CRM, 'download' = Pinakes Export;
 * 'database' chosen for Callimachus, the data-collection tool). Inlined so they render
 * in `currentColor`. Font Awesome by Dave Gandy — https://fontawesome.com (CC BY 4.0).
 */
const PATHS: Record<string, string> = {
  crm: 'M1216 832q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zm512 832q0 52-38 90t-90 38q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z',
  export:
    'M1344 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h465l135 136q58 56 136 56t136-56l136-136h464q40 0 68 28t28 68zm-325-569q17 41-14 70l-448 448q-18 19-45 19t-45-19l-448-448q-31-29-14-70 17-39 59-39h256v-448q0-26 19-45t45-19h256q26 0 45 19t19 45v448h256q42 0 59 39z',
  callimachus:
    'M896 768q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zm0 768q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zm0-384q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zm0-1152q208 0 385 34.5t280 93.5 103 128v128q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-128q0-69 103-128t280-93.5 385-34.5z',
};

/** The inline SVG glyph for an app key ('crm' | 'export' | 'callimachus'), or null when unknown. */
export function appIcon(app: string): TemplateResult | null {
  const d = PATHS[app];
  return d
    ? html`<svg viewBox="0 0 1792 1792" fill="currentColor" aria-hidden="true">
        <path d=${d} />
      </svg>`
    : null;
}
